// ---------------------------------------------------------------------------
// nav — header navigation behaviour.
//   * adds `.scrolled` to <nav.main-nav> once the page is scrolled past the
//     top fold (drives the landing nav's solid background).
//   * toggles the mobile menu: `.is-active` on the hamburger + the
//     `mobile-nav-visible` class on <html> that slides the panel in.
//   * accordion-toggles submenu sections on mobile (`.submenu-section--open`).
// ---------------------------------------------------------------------------

import { isSmallOnly } from './matchMedia';

export const initNav = (): void => {
	const nav = document.querySelector('nav.main-nav');
	if (nav) {
		const onScroll = (): void => {
			nav.classList.toggle('scrolled', window.scrollY > 5);
		};
		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
	}

	const hamburger = document.querySelector<HTMLButtonElement>('.hamburger');
	hamburger?.addEventListener('click', () => {
		const active = hamburger.classList.toggle('is-active');
		document.documentElement.classList.toggle('mobile-nav-visible', active);
		hamburger.setAttribute('aria-expanded', String(active));
	});

	// Submenu accordions — mobile only; let desktop hover handle dropdowns.
	const titles = document.querySelectorAll<HTMLElement>('.submenu-section__title');
	for (const title of titles) {
		title.addEventListener('click', (event) => {
			if (!isSmallOnly()) return;
			const section = title.closest('.submenu-section');
			if (!section || !section.querySelector('.submenu-list')) return;
			event.preventDefault();
			section.classList.toggle('submenu-section--open');
		});
	}
};
